import { FieldValue, increment } from 'firebase/firestore';
import uniqid from 'uniqid';
import { Store, StoreLog, Worker } from '../../apiTypes';
import { createBatch } from '../../utils/api';

type Props = {
  cafeSlug: string;
  fromStore: DbDocument<Store>;
  toStore: DbDocument<Store>;
  components: { id: string; qnt: number }[];
  worker: DbDocument<Worker>;
};

export const moveProducts = async ({ cafeSlug, fromStore, toStore, components, worker }: Props) => {
  const fromStoreChanges: Record<`residues.${string}`, FieldValue> = {};
  const toStoreChanges: Record<`residues.${string}`, FieldValue> = {};
  const fromStoreDiff: Record<string, number> = {};
  const toStoreDiff: Record<string, number> = {};

  components.forEach(({ id, qnt }) => {
    if (qnt) {
      fromStoreChanges[`residues.${id}`] = increment(-qnt);
      toStoreChanges[`residues.${id}`] = increment(qnt);
      fromStoreDiff[id] = -qnt;
      toStoreDiff[id] = qnt;
    }
  });

  const batch = createBatch();

  batch.update<Store>(`cafes/${cafeSlug}/stores/${fromStore.id}`, fromStoreChanges);
  batch.update<Store>(`cafes/${cafeSlug}/stores/${toStore.id}`, toStoreChanges);

  const fromStoreLog: StoreLog = {
    time: new Date().getTime(),
    workerId: worker.id,
    workerName: worker.name,
    storeId: fromStore.id,
    type: 'transfer',
    diff: fromStoreDiff,
    info: {
      type: 'transfer',
      from: { name: fromStore.name, id: fromStore.id },
      to: { name: toStore.name, id: toStore.id },
    },
  };

  const toStoreLog: StoreLog = {
    time: new Date().getTime(),
    workerId: worker.id,
    workerName: worker.name,
    storeId: toStore.id,
    type: 'transfer',
    diff: toStoreDiff,
    info: {
      type: 'transfer',
      from: { name: fromStore.name, id: fromStore.id },
      to: { name: toStore.name, id: toStore.id },
    },
  };

  batch.set<StoreLog>(`cafes/${cafeSlug}/storeLogs/${uniqid()}`, fromStoreLog);
  batch.set<StoreLog>(`cafes/${cafeSlug}/storeLogs/${uniqid()}`, toStoreLog);

  await batch.commit();
};
